import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { PageSection } from '@gik/ui';
import InkindUsesGrid from './InkindUsesGrid';

export interface IInkindUsesSectionProps {
  cols: number;
  perPage: number;
}

export default function InkindUsesSection({ cols, perPage }: IInkindUsesSectionProps): React.ReactElement {
  const bem = bemBlock('inkind-uses-section');
  const { t } = useTranslation();
  return (
    <PageSection id="how-others-are-using-inkind" className={bem()}>
      <h2 className={bem('title')}>{t(translationKeys.title)}</h2>
      <InkindUsesGrid cols={cols} perPage={perPage} />
    </PageSection>
  );
}
